import React from 'react';
import { Card } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import pluralize from 'pluralize';

import { HealthQuoteBenefitSchedule } from '@models/HealthQuote';
import { HealthQuoteBenefitScheduleAccordion } from './health-quote-benefit-schedule-accordion';

const HealthQuoteBenefitScheduleCardBody = (props: HealthQuoteBenefitSchedule) => {
  const { t } = useTranslation();

  return (
    <Card.Body>
      <Card.Title>{pluralize(t('common:benefit'), 2)}</Card.Title>
      <HealthQuoteBenefitScheduleAccordion {...props} />
    </Card.Body>
  );
};

export { HealthQuoteBenefitScheduleCardBody };
